export default __webpack_public_path__ + "static/media/gfi.f72a7e8a.png";